import { useEvidence } from './EvidenceContext';

export function EvidenceBadge({ id, label }: { id: string | undefined; label?: string }): JSX.Element | null {
  const { setActive, scrollTo } = useEvidence();
  if (!id) return null;
  return (
    <button
      type="button"
      className="inline-flex items-center rounded bg-sky-50 px-1 py-0 text-[10px] font-mono text-sky-700 hover:bg-sky-100"
      onClick={(e) => {
        e.stopPropagation();
        setActive(id);
        scrollTo(id);
      }}
      title={`Jump to evidence ${id}`}
    >
      {label ?? id}
    </button>
  );
}

export function EvidenceBadgeList({ ids }: { ids: string[] | undefined }): JSX.Element | null {
  if (!ids || ids.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1">
      {ids.map((id) => (
        <EvidenceBadge key={id} id={id} />
      ))}
    </div>
  );
}
